/**
 * Enumération des types de contacts possible
 */
export enum TypeContact {
    MOBILE = 'MOBILE',
	TELEPHONE_PROFESSIONNEL = 'TELEPHONE_PROFESSIONNEL',
	TELEPHONE_PERSONNEL = 'TELEPHONE_PERSONNEL',
	CONTACT_URGENCE = 'CONTACT_URGENCE',
	EMAIL_ASSISTANT = 'EMAIL_ASSISTANT'
}